/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HttpModule
 */

export function removeLeadingSlash(url: string): string {
    if (url.startsWith('/')) {
        url = url.slice(1);
    }

    return url;
}
